/**
 * Created by Tiger on 24/02/2022.
 */
import {combineReducers} from 'redux';
import language from './language';
import config from './config';
import device from './device';
import header from './header';

const reducer = combineReducers({
  language, config, device, header,
});

export default reducer;